//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref } from '@vue/composition-api'
import { mdiHeartOutline, mdiBookmarkOutline, mdiShareVariant } from '@mdi/js'

export default {
  setup() {
    const fav = ref(true)
    const menu = ref(false)
    const message = ref(false)
    const hints = ref(true)

    return {
      fav,
      menu,
      message,
      hints,

      // Icons
      icons: {
        mdiHeartOutline,
        mdiBookmarkOutline,
        mdiShareVariant,
      },
    }
  },
}
